import { PropsWithClassname } from '@/app/types';

export const CoinsIcon = ({ className }: PropsWithClassname) => {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.932 12.501a5 5 0 1 1 8.66-5 5 5 0 0 1-8.66 5ZM8.37 8.774A6.972 6.972 0 0 0 9.2 13.5a6.972 6.972 0 0 0 3.68 3.082 4.582 4.582 0 0 1-1.546 1.46c-2.255 1.301-5.239.48-6.638-1.942-1.398-2.422-.617-5.417 1.638-6.719a4.583 4.583 0 0 1 2.036-.608Zm6.576 8.22a6.595 6.595 0 0 1-2.612 2.78c-3.272 1.89-7.455.644-9.37-2.673-1.915-3.317-.902-7.562 2.37-9.45a6.595 6.595 0 0 1 3.713-.873 7 7 0 1 1 5.899 10.217Z"
        fill="currentColor"
      />
    </svg>
  );
};
